export default function Dialog({ children }: { children: React.ReactNode }) {
  return (
    <div className="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
      <div className="fixed inset-0 bg-black/50 transition-opacity" aria-hidden="true"></div>

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex h-screen flex-col items-end justify-center p-4 text-center">
          <div className="relative w-full flex-1 grow overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}
